module.exports = __webpack_public_path__ + "img/colab-logo.1f7a3401.svg";